import { Component, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { of, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TourGuideService } from '@app/services/tour-guide.service';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import dummyData from '@app/assets/api-dummy-data.json';
@Component({
  selector: 'app-auto-complete-dropdown',
  templateUrl: './auto-complete-dropdown.component.html',
  styleUrls: ['./auto-complete-dropdown.component.scss']
})

export class AutoCompleteDropdownComponent implements OnChanges {

  /****************** Variable declaration ******************/
  filteredOptions: any; //dropdown list
  optionCtrl: FormControl; //form input 
  dataSubscription: Subscription

  /****************** View child ******************/
  @ViewChild('select') matAutocomplete: MatAutocomplete;
  @ViewChild('autocompleteInput') autocompleteInput: ElementRef<HTMLInputElement>;
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger: MatAutocompleteTrigger;

  /****************** Input and Output decorators ******************/
  @Input() dropDownOptions: any[]
  @Input() style: any = {
    outline: "auto",
    width: "16rem",
    "border-radius": "3px 3px 0 0",
    "outline-color": "#959593",
    border: "none",
    padding: "9.2px 11px"
  }
  @Input() sltOption: any;
  @Input() placeholder: any;
  @Output() selectedOptions = new EventEmitter<any>()

  /**
   * Constructor
   * @param guideService 
   * @param constants 
   */
  constructor(private guideService: TourGuideService) {
    this.dataSubscription = this.guideService.data$.subscribe((res: any) => {
      if (this.matAutocomplete && this.autocompleteInput) {
        if(res?.page === 'Access') {
          this.filteredOptions = dummyData.Access; 
        }
        if (res?.operation === 'open') {
          this.autocompleteInput.nativeElement.focus();
          if (this.guideService.isStartTour) {
            this.autocompleteInput.nativeElement.setAttribute('readonly', 'true');
          }
        }
        if (res?.operation === 'close') {
          this.autocompleteTrigger.closePanel();
          if (this.guideService.isStartTour) {
            this.autocompleteInput.nativeElement.removeAttribute('readonly')
          }
        }
        if (res?.operation === 'skip') {
          this.autocompleteInput.nativeElement.removeAttribute('readonly')
        }
      }
    })
  }

  /** ngOnChanges */
  ngOnChanges(): void {
    // Tour guide is there than dummy data to be passed
    this.optionCtrl = new FormControl();
    if (this.guideService.isStartTour) {
      of(dummyData.dropdownRepos).toPromise().then((data:any) => {
        this.filteredOptions = data;
      });
      this.sltOptionSelection();
      return;
    }
    this.filteredOpt();

    // this will Set the value of the input field to the first option when dropDownOptions change.
    if (this.dropDownOptions && this.dropDownOptions.length > 0) {
      this.sltOptionSelection();
    }
  }

  /**selection option according to the incoming value */
  sltOptionSelection() {
    return this.sltOption?.name ? this.optionCtrl.setValue(this.sltOption?.name) : this.optionCtrl.setValue(this.sltOption)
  }

  /** dropdown list */
  dropdownList() {
    this.filteredOptions = this.dropDownOptions;
  }

  /** filterOptions */
  filterOptions(name: string) {
    return this.dropDownOptions.filter(option => {
      if (typeof option === 'string') {
        return option.toLowerCase().includes(name.toLowerCase());
      } else if (typeof option === 'object' && option.hasOwnProperty('name')) {
        return option.name.toLowerCase().includes(name.toLowerCase());
      }
      return false;
    });
  }

  /**
   * @param $event gives a selected option event
   */
  onSelectionChange($event: any) {
    if ($event) {
      this.optionCtrl.patchValue($event.option.value.name || $event.option.value);
      this.filteredOpt();
      this.selectedOptions.emit($event.option.value);
    }
  }

  /** filter options */
  filteredOpt() {
    this.optionCtrl.valueChanges.pipe(
      startWith(''),
      map(option => option ? this.filterOptions(option?.name ? option.name : option) : this.dropDownOptions.slice())
    )
      .subscribe(filteredOpts => {
        this.filteredOptions = filteredOpts; // Assign the results to the regular array
      });
  }

  /** open auto complete dropdown */
  openAutocomplete(): void {
    this.autocompleteInput.nativeElement.focus();
  }
}
